import React, { Component } from 'react';
import { convertTargetBooleanToString, convertRelStringToObject, convertRelObjectToString, convertTargetStringToBoolean } from 'wix-rich-content-common';
import LinkPanel from './LinkPanel.js';
import { merge } from 'lodash';
import 'prop-types';
import 'classnames';
import 'wix-rich-content-common/libs/Tooltip';
import 'wix-rich-content-ui-components';
import './AdvancedCheckboxes.js';
import './consts.js';
import '../../link-panel-d6b164a2.js';
import '../../style-inject.es-746bb8ed.js';
import './LinkPanelDropdown.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
class LinkPanelWrapper extends Component {
  constructor() {
    super(...arguments);
    this.onChange = (changes) => {
      const { linkValues, relValue } = this.props;
      const _a = changes, { targetBlank, nofollow, sponsored, noreferrer } = _a, rest = __objRest(_a, ["targetBlank", "nofollow", "sponsored", "noreferrer"]);
      const target = convertTargetBooleanToString(targetBlank);
      const relObject = merge(
        convertRelStringToObject(relValue),
        convertRelStringToObject(linkValues.rel),
        {
          nofollow,
          sponsored,
          noreferrer
        }
      );
      const rel = convertRelObjectToString(relObject);
      const newLinkValues = __spreadValues(__spreadProps(__spreadValues({}, linkValues), { target, rel }), rest);
      this.props.onChange(newLinkValues);
    };
  }
  render() {
    const { linkValues, relValue, anchorTarget } = this.props;
    const _a = linkValues, { rel = relValue, target = anchorTarget, url = "" } = _a, rest = __objRest(_a, ["rel", "target", "url"]);
    const { nofollow, sponsored, noreferrer } = convertRelStringToObject(rel) || {};
    const targetBlank = convertTargetStringToBoolean(target);
    const linkPanelValues = __spreadProps(__spreadValues({}, rest), { targetBlank, nofollow, sponsored, noreferrer, url });
    return /* @__PURE__ */ React.createElement(LinkPanel, __spreadProps(__spreadValues({}, this.props), { linkValues: linkPanelValues, onChange: this.onChange }));
  }
}

export { LinkPanelWrapper as default };
//# sourceMappingURL=LinkPanelWrapper.js.map
